/* eslint-disable react/jsx-boolean-value, no-nested-ternary */
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
// import { createOptionMap, isBrowser } from '../../utilities/misc';
import styled from '@emotion/styled';
import { NoSSR } from 'next-dynamic-no-ssr';

import { createOptionMap, isBrowser } from '../../utilities/misc';
import useUserContext from '../../hooks/use-user-context';

const TrialForm = React.lazy(() => import('./TrialForm'));
const TrialFormSteps = React.lazy(() => import('./TrialFormSteps'));

const LoadingMessage = styled.p`
  text-align: center;
`;

const TrialFormLoader = ({ variation }) => {
  // const myVariation = 'sos';
  const data = useStaticQuery(graphql`
    query TrialFormLoaderGlobals {
      allContentfulOptionSet(filter: {name: {eq: "globals"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);

  const { language, abTests } = useUserContext();
  const stepsTestIndex = abTests.indexOf('steps');

  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const message = options['globals.hubspot_form_loading_message'];
  return (
    <NoSSR>
      <Suspense fallback={<LoadingMessage>{message}</LoadingMessage>}>
        {isBrowser
          ? (
            stepsTestIndex < 0 ? (
              <TrialForm variation={variation} isBrowser createOptionMap />
            ) : (
              <TrialFormSteps variation={variation} isBrowser createOptionMap />
            )
          ) : (
            <LoadingMessage>{ message }</LoadingMessage>
          )}
      </Suspense>
    </NoSSR>
  );
};

TrialFormLoader.propTypes = {
  variation: PropTypes.string
};

export default TrialFormLoader;
